import { render } from "./CampaignLargeItem.vue?vue&type=template&id=9345acc6"
import script from "./CampaignLargeItem.vue?vue&type=script&lang=js"
export * from "./CampaignLargeItem.vue?vue&type=script&lang=js"

import "./CampaignLargeItem.vue?vue&type=style&index=0&id=9345acc6&lang=css"
script.render = render

export default script